/**
 * Created by andrey on 30.08.16.
 */
export class InvoiceCalculations {
    reDeliveryCost: number;
    deliveryCost: number;
}
